module.exports = "//public.getcloudapp.com/packs/media/images/zight-logo-180-41-b89d827b207adb08db3c93f245c68854.svg";